module.exports = __webpack_public_path__ + "static/media/8x8no3.b0581dfa.jpg";